import {
  TEventSpecificData,
  TMableEvent,
} from '@/core/constants/event_types/base_mable_event';

import {
  GAdsConversionPayload,
  GadsPayloadRetailItem,
} from '../google_ads_types';

import { EMableEventName } from '../../../../core/constants/event_types/events';

type PayloadParams = {
  mableEvent: TMableEvent;
};

export const GoogleAdsPayloadManager = {
  calculatePayload({ mableEvent }: PayloadParams): GAdsConversionPayload {
    const { en, esd } = mableEvent;
    const basePayload: any = {};
    const currency = this.getCurrency(esd);
    const items = this.getRetailItems(esd);
    const value = Number(this.getValue(en, esd) || 0);
    if (currency) {
      basePayload.currency = currency;
    }
    if (items.length > 0) {
      basePayload.items = items;
    }
    if (value) {
      basePayload.value = value;
    }
    return esd?.oid ? { ...basePayload, transaction_id: esd.oid } : basePayload;
  },

  createRetailItem(product: { id?: string }): GadsPayloadRetailItem {
    return {
      google_business_vertical: 'retail',
      id: product?.id || '',
    };
  },

  getCurrency(esd?: TEventSpecificData): string {
    return esd?.cart?.currency || esd?.act_product?.cur || '';
  },

  getRetailItems(esd?: TEventSpecificData): GadsPayloadRetailItem[] {
    if (!esd) return [];

    if (esd.cart?.products) {
      return esd.cart.products.map(this.createRetailItem);
    }

    return esd?.act_product ? [this.createRetailItem(esd?.act_product)] : [];
  },

  getValue(en: EMableEventName, esd?: TEventSpecificData): string | undefined {
    if (esd?.cv_data?.cv !== undefined) {
      return esd.cv_data.cv.toString();
    }

    if (en === EMableEventName.PRODUCT_ADDED) {
      let parsedPrice = 0;
      try {
        parsedPrice = Number.parseFloat(esd?.act_product?.prc || '0');
      } catch {
        parsedPrice = 0;
      }

      return ((esd?.qty_act_product || 1) * parsedPrice).toString();
    }
    if (
      en === EMableEventName.PRODUCT_VIEWED ||
      en === EMableEventName.COLLECTION_VIEWED
    ) {
      return esd?.act_product?.prc.toString();
    }
    return (
      esd?.cart?.total?.price.toString() || esd?.act_product?.prc?.toString()
    );
  },
};
